if (!customElements.get('marquee-track')) {
  customElements.define(
    'marquee-track',
    class MarqueeTrack extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.marquee-track__viewport');
        this.groups = this.querySelectorAll('.marquee-track__group');

        if (!this.viewport || this.groups.length < 2) return;

        this.speed = Math.max(parseFloat(this.dataset.speed) || 50, 1);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.onReducedMotionChange = () => {
          this.updateAnimation();
        };
        this.reducedMotion.addEventListener('change', this.onReducedMotionChange);

        this.resizeObserver = new ResizeObserver(() => {
          this.updateAnimation();
        });
        this.resizeObserver.observe(this);
        this.groups.forEach((group) => {
          this.resizeObserver.observe(group);
        });

        this.updateAnimation();
        this.querySelectorAll('img').forEach((image) => {
          if (image.complete) return;
          image.addEventListener('load', () => this.updateAnimation(), { once: true });
        });
      }

      disconnectedCallback() {
        this.reducedMotion?.removeEventListener('change', this.onReducedMotionChange);
        this.resizeObserver?.disconnect();
      }

      updateAnimation() {
        if (this.reducedMotion?.matches) {
          this.classList.add('marquee-track--static');
          this.style.removeProperty('--marquee-duration');
          return;
        }

        const groupWidth = this.groups[0]?.getBoundingClientRect().width || 0;

        if (!groupWidth) {
          this.classList.add('marquee-track--static');
          this.style.removeProperty('--marquee-duration');
          return;
        }

        this.classList.remove('marquee-track--static');
        const duration = groupWidth / this.speed;
        this.style.setProperty('--marquee-duration', `${duration}s`);
      }
    }
  );
}
